import React from "react";
import PropTypes from "prop-types";
import { Box } from "orcs-design-system";
import { useFocused } from "slate-react";

import { useWorkspaceTagConfig } from "src/contexts/global/WorkspaceContext";
import { getTagTypeName } from "src/util/tags";
import HashTag from "src/components/Tag";

const MentionElement = (props) => {
  const { attributes, element, children } = props;
  const focused = useFocused();
  const tagConfig = useWorkspaceTagConfig();
  const typeLabel = getTagTypeName(element?.tag?.type, tagConfig);

  return (
    <Box
      display="inline-block"
      mr="xs"
      {...attributes}
      contentEditable={false}
      data-testid="cp-rte-plugin-mention"
    >
      <HashTag
        element={element}
        selected={true}
        focused={focused}
        tagTypeLabel={typeLabel}
      />
      {children}
    </Box>
  );
};

MentionElement.propTypes = {
  element: PropTypes.object,
  attributes: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default MentionElement;
